import React from "react";
import { Switch, Route } from "react-router-dom";

import Nav from "components/Nav";
import TopNav from "components/TopNav";
import Home from "pages/Home";
import Products from "pages/Products";
import Folder from "pages/Folder";
import Contact from "pages/Contact";
import Footer from "components/Footer";
import FooterSmall from "components/FooterSmall";

import { routes } from "config";

const App: React.FC = () => {
  return (
    <>
      <>
        <TopNav />
        <Nav />
      </>
      <Switch>
        {/* <Route exact path="/">
          <TemporaryHome />
        </Route> */}
        <Route exact={routes[0].exact} path={routes[0].path}>
          <Home />
        </Route>
        <Route exact={routes[1].exact} path={routes[1].path}>
          <Products />
        </Route>
        <Route exact={routes[2].exact} path={routes[2].path}>
          <Folder />
        </Route>
        <Route exact={routes[3].exact} path={routes[3].path}>
          <Contact />
        </Route>
      </Switch>
      <Footer />
      <FooterSmall />
    </>
  );
};

export default App;
